import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "datepicker-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-3" }, [
  /*#__PURE__*/_createTextVNode("Pierwszy dzień zwoIոіеոia "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import Datepicker from '../../ui/Datepicker.vue';
import { useField } from 'vee-validate';


export default {
  __name: 'DateOfIllnessField',
  setup(__props) {

const { value, errorMessage } = useField('dateOfIllness');

const minDate = new Date().setDate(new Date().getDate() - 2);
const maxDate = new Date().setDate(new Date().getDate() + 2);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Datepicker, {
      name: "dateOfIllness",
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null))
    }, null, 8, ["min-date", "max-date", "modelValue"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}